export default {"src":"/_next/static/media/apple_pay_logo.9595ad76.svg","height":22,"width":33,"blurWidth":0,"blurHeight":0};